import type { ReactNode } from 'react';
import type { IconComponent, IconProps } from 'mx-icons';
import { TagTwotone } from 'mx-icons/components/tag';
import { ShoppingCartTwotone } from 'mx-icons/components/shopping-cart';
import { LifebuoyTwotone } from 'mx-icons/components/lifebuoy';
import { UserEditTwotone } from 'mx-icons/components/user-edit';
import { ClipboardTextTwotone } from 'mx-icons/components/clipboard-text';
import { TruckTickTwotone } from 'mx-icons/components/truck-tick';
import { PeopleTwotone } from 'mx-icons/components/people';
import { ShopTwotone } from 'mx-icons/components/shop';
import { DocumentTextTwotone } from 'mx-icons/components/document-text';
import { BoxTwotone } from 'mx-icons/components/box';
import { MX_NAV_ICON } from './mxTwotoneIcon';
import {
  getEntityRegistryEntry,
  type EntityIconKey,
} from './entityRegistry';

const ENTITY_ICON_BY_KEY: Record<EntityIconKey, IconComponent> = {
  tag: TagTwotone,
  'shopping-cart': ShoppingCartTwotone,
  lifebuoy: LifebuoyTwotone,
  'user-edit': UserEditTwotone,
  'clipboard-text': ClipboardTextTwotone,
  'truck-tick': TruckTickTwotone,
  people: PeopleTwotone,
  shop: ShopTwotone,
  'document-text': DocumentTextTwotone,
  box: BoxTwotone,
};

const FALLBACK_ICON = BoxTwotone;

export function getEntityIconComponent(entityType: string | null | undefined): IconComponent {
  const key = getEntityRegistryEntry(entityType)?.iconKey;
  return (key && ENTITY_ICON_BY_KEY[key]) || FALLBACK_ICON;
}

export type EntityIconProps = IconProps & {
  entityType: string | null | undefined;
  className?: string;
};

/** Twotone glyph for entity type — size/color default to nav chrome. */
export function EntityIcon({ entityType, className, ...props }: EntityIconProps): ReactNode {
  const Icon = getEntityIconComponent(entityType);
  return <Icon {...MX_NAV_ICON} {...props} className={className} aria-hidden />;
}
